import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringify',
  standalone: true,
})
export class StringifyPipe implements PipeTransform {
  transform(value: Record<string, any> | undefined, returnUndefinedIfNoValue = false): string | undefined {
    if (!value) {
      return returnUndefinedIfNoValue ? undefined : '';
    }

    return JSON.stringify(value);
  }
}
